import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, EMPTY, throwError } from 'rxjs';
import { AuthService } from '../services/auth-service';
import { IServerError } from '../../constants/interface/common';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const error: IServerError = err.error
      let handle_error: string[] = ["unauthorized_token", "account_disabled", "role_changed"]
      if (err.status === 0) {
        messageService.add({ severity: 'error', summary: 'Error', detail: 'Network error. Please check your connection.' });
      } else if (handle_error.includes(error.error_message_code)) {
        authService.clearToken();
        router.navigate(['/sign-in']);
        if (error.error_message_code == "account_disabled") {
          messageService.add({ severity: 'error', summary: 'Error', detail: 'Account disabled. Contact admin' });
        } else if (error.error_message_code == "role_changed") {
          messageService.add({ severity: 'error', summary: 'Error', detail: 'Your role in company has been changed. Please Sign in to access the application' });
        }
        return EMPTY;
      }
      return throwError(() => err);
    })
  );
};
